import React, { Fragment } from 'react';
import Modal from 'library/components/modal';
import BrowseTargetsModal from 'apps/hiring/components/browse-targets-modal';

class BrowseTargets extends React.Component {
  static defaultProps = {
    children: 'Add Target',
    onTargets: ()=>{}
  }

  state = {
    active: false
  }

  toggleModal = () => {
    this.setState({
      active: !this.state.active
    });
  }

  handleOnTargets = async (targets) => {
    await this.props.onTargets(targets);
    this.setState({
      active: false
    });
  }

  render() {
    const {
      children,
      component:Component='button',
      onTargets,
      addLabel='ADD',
      exclude=[],
      activeTargets=[],
      ...props
    } = this.props;

    return (
      <Fragment>
        <Component onClick={this.toggleModal} {...props}>{children}</Component>
        <Modal onClose={this.toggleModal} active={this.state.active}>
          <BrowseTargetsModal activeTargets={activeTargets} addLabel={addLabel} onClose={this.toggleModal} exclude={exclude} onTargets={this.handleOnTargets} />
        </Modal>
      </Fragment>
    );
  }
}

export default BrowseTargets;
